import React, { useState } from 'react';

export const ProfileAvatar = ({ name }) => {
  const [isError, setIsError] = useState(false);
  const imagePath = `${process.env.PUBLIC_URL}/profile/${name}.png`;

  if (!name || name === "none") return null;

  return (
    <div className="flex items-center justify-center h-full">
      {!isError ? (
        <img
          src={imagePath}
          alt={name}
          style={{ height: "50px", width: "50px" }}
          className="rounded-full object-cover"
          onError={() => setIsError(true)}
        />
      ) : (
        <div 
          className= "flex items-center justify-center w-[49px] h-[49px] border-solid border-2 border-[#739D00] rounded-full font-rubik font-light text-[20px] leading-tight tracking-wide-5 uppercase"
        >
          {name.charAt(0).toUpperCase()}
        </div>
      )}
    </div>
  );
};

